import KidoAPIInstance from "../../services/KidoConfigApi";

export const cancelDeleteAccountApi = async () => {
	const path = "api/cancelDelete";
	return await KidoAPIInstance.post(path);
};

export const deleteAccountApi = async data => {
	const path = "api/delete";
	return await KidoAPIInstance.post(path, data);
};

export const getCheckTokenLoginApi = async token => {
	const path = `api/validateToken?token=${token}`;
	return await KidoAPIInstance.get(path);
};

export const getValidateLoginFaceIdApi = async () => {
	const path = "api/validateLoginFaceId";
	return await KidoAPIInstance.get(path);
};

export const postChangePasswordApi = async data => {
	const path = "api/changePassword";
	return await KidoAPIInstance.post(path, data);
};

export const postCreateNewPasswordApi = async data => {
	const path = "api/createNewPassword";
	return await KidoAPIInstance.post(path, data);
};

export const postLoginApi = async data => {
	const path = "api/login";
	return await KidoAPIInstance.post(path, data);
};

export const postLogoutApi = async () => {
	const path = "api/logout";
	return await KidoAPIInstance.post(path);
};

export const postOffLoginWithFaceIdApi = async () => {
	const path = "api/offLoginWithFaceId";
	return await KidoAPIInstance.post(path);
};

export const postOnLoginWithFaceIdApi = async () => {
	const path = "api/onLoginWithFaceId";
	return await KidoAPIInstance.post(path);
};

export const postRegisterApi = async data => {
	const path = "api/register";
	return await KidoAPIInstance.post(path, data);
};

export const postValidatePasswordApi = async data => {
	const path = "api/validatePassword";
	return await KidoAPIInstance.post(path, data);
};

export const checkRegisterDeviceApi = async data => {
	const path = `api/checkRegisterDevice?uid=${data.uid}&modelName=${data.modelName}&pl=${data.pl}`;
	return await KidoAPIInstance.get(path);
};

export const approvedStatusDeviceApi = async data => {
	const path = "api/approvedStatusDevice";
	return await KidoAPIInstance.post(path, data);
};
